<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="department.departmentID > 0 ? '编辑' : '新建'"
        class="department-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="department"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="编号">
          <el-input v-model="department.departmentNO" disabled/>
        </el-form-item>
        <el-form-item label="部门名称" prop="departmentName">
          <el-input v-model="department.departmentName" placeholder="请输入部门名称"/>
        </el-form-item>
        <el-form-item label="外部编号">
          <el-input v-model="department.outerNO" placeholder="请输入外部编号"/>
        </el-form-item>
        <el-form-item label="部门主管" prop="directorName">
          <el-input v-model="department.directorName" placeholder="请选择部门主管" readonly>
            <el-button slot="append" @click="$refs.selectEmployee.open()">选择</el-button>
          </el-input>
          <employee-select ref="selectEmployee" @select="selectEmployee"/>
        </el-form-item>
        <el-form-item label="上级部门">
          <el-input v-model="department.parentName" placeholder="请选择上级部门" readonly>
            <el-button slot="append" @click="$refs.selectDepartment.open()">选择</el-button>
          </el-input>
          <department-select ref="selectDepartment" @select="selectDepartment"/>
        </el-form-item>
        <el-form-item label="传真">
          <el-input v-model="department.fax" placeholder="请输入传真"/>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="department.telephone" placeholder="请输入电话"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="department.note" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";

  export default {
    name: "DepartmentEdit",
    components: { EmployeeSelect, DepartmentSelect },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        department: {
          departmentID: 0,
          departmentNO: "",
          departmentName: "",
          outerNO: "",
          directorID: 0,
          directorName: "", //部门主管
          employeeName: "",
          telephone: "",
          fax: "",
          parentID: 0,
          parentName: "", //上级部门
          note: "",
        },
        ruleValidate: {
          departmentName: { required: true, message: "请输入部门名称", trigger: "blur" },
          // directorName: { required: true, message: "请选择部门主管", trigger: "change" },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (!row) {
          this.getDepartmentNo();
        } else {
          this.getData(row);
        }
      },

      // 获取部门编号
      getDepartmentNo() {
        this.$http.get("basic", "departments/selectDepartmentNo").then((resp) => {
          if (resp.success) {
            this.department.departmentNO = resp.data;
          }
        });
      },

      // 选择员工
      selectEmployee(row) {
        this.department.directorID = row.employeeID;
        this.department.directorName = row.employeeName;
      },

      // 选择部门
      selectDepartment(row) {
        this.department.parentID = row.departmentID;
        this.department.parentName = row.departmentName;
      },

      // 根据部门id查询部门信息
      getData(departmentID) {
        this.$http.get("basic", `departments/${departmentID}`).then((resp) => {
          if (resp.success) {
            this.department = resp.data;
          }
        });
      },

      // 提交
      handleSubmit() {
        if (this.department.departmentID > 0) {
          this.handleSubmitUpData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "departments", this.department)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "departments", this.department)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
